export function normalizeId(id) {
  if (!id) return "";
  // Remove all non-ASCII characters like en-dash, em-dash, weird unicode
  return id.replace(/[^A-Za-z0-9-]/g, "");
}



export function isCustomer(user){
    return user.role=="Customer";
}

export function isTechnician(user){
    return user.role=="Technician";
}
export function isAdmin(user){
    console.log(!isCustomer(user) && !isTechnician(user));
    return (!isCustomer(user) && !isTechnician(user));
}
